import { WelcomeModal } from "@/modules/gateway/features/open-external-sign/ui/welcome-modal/welcome-modal";
import ExternalSignPage from "@/modules/gateway/features/open-external-sign/ui/external-sign-page";
import { useRegistrationByCode } from "@/modules/gateway/features/open-external-sign/model/use-registration-by-code";
import Card from "@/shared/data-display/card";
import { Result } from "@/shared/feedback/result";
import { useTranslations } from "use-intl";
import { useCode } from "@/modules/gateway/features/open-external-sign/model/use-code";

export function OpenExternalSign() {
  const t = useTranslations("Signing");
  const { code } = useCode();
  const { registration } = useRegistrationByCode({ code });

  if (!code) {
    return (
      <Card>
        <Result status={"error"} title={t("No code provided")} />
      </Card>
    );
  }

  if (!registration) return null;

  return (
    <div className={"w-full py-10"}>
      <ExternalSignPage signRegistration={registration} />
      <WelcomeModal />
    </div>
  );
}
